import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  errors: [],
  lastOffer: null,
  adminOffers: { isLoading: false, data: {}, errors: [] },
};

export const createShopItemOffer = createAsyncThunk('shopItemOffers/createShopItemOffer', async (args, thunkApi) => {
  try {
    const { data } = await axios.post('/api/create_shop_item_offer', args, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const getAllShopItemOffers = createAsyncThunk('shopItemOffers/getAllShopItemOffers', async (args, thunkApi) => {
  try {
    const { page = 1, size = 10, filter = JSON.stringify({}) } = args || {};
    const { data } = await axios.get(`/api/get_all_shop_item_offers?page=${page}&size=${size}&filter=${filter}`, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const updateShopItemOfferStatus = createAsyncThunk('shopItemOffers/updateShopItemOfferStatus', async (args, thunkApi) => {
  try {
    const { id, ...body } = args;
    const { data } = await axios.patch(`/api/update_shop_item_offer_status/${id}`, body, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

const shopItemOffersSlice = createSlice({
  name: 'shopItemOffers',
  initialState,
  extraReducers: {
    [createShopItemOffer.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [createShopItemOffer.fulfilled]: (state, action) => { state.isLoading = false; state.lastOffer = action.payload.data; },
    [createShopItemOffer.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [getAllShopItemOffers.pending]: (state) => { state.adminOffers.isLoading = true; state.adminOffers.errors = []; },
    [getAllShopItemOffers.fulfilled]: (state, action) => {
      state.adminOffers.isLoading = false;
      state.adminOffers.data = action.payload;
    },
    [getAllShopItemOffers.rejected]: (state, action) => {
      state.adminOffers.isLoading = false;
      state.adminOffers.data = {};
      state.adminOffers.errors = action.payload.errors;
    },

    [updateShopItemOfferStatus.pending]: (state) => { state.adminOffers.isLoading = true; state.adminOffers.errors = []; },
    [updateShopItemOfferStatus.fulfilled]: (state, action) => {
      state.adminOffers.isLoading = false;
      const updated = action.payload.data;
      const idx = state.adminOffers.data.data?.findIndex(el => el._id === updated._id);
      if (idx !== undefined && idx > -1) state.adminOffers.data.data[idx] = updated;
    },
    [updateShopItemOfferStatus.rejected]: (state, action) => {
      state.adminOffers.isLoading = false;
      state.adminOffers.errors = action.payload.errors;
    },
  }
});

export default shopItemOffersSlice.reducer;
